import React from 'react';
import { FormRowLayoutProps } from '../index';
import { FormRowsGroupLayoutProps } from 'ui-builder';
import useFeatureToggleService from 'feature-toggle';
import { ShadcnFormRowLayout, ShadcnFormRowsGroupLayout } from './ShadcnFormRowLayout';

function LegacyFormRowLayout(props: FormRowLayoutProps) {
  return (
    <div className="form-row" data-testid={props.testId}>
      {props.children}
    </div>
  );
}

function LegacyFormRowsGroupLayout(props: FormRowsGroupLayoutProps) {
  return (
    <div className="form-rows">
      {props.children}
    </div>
  );
}

function FormRowLayout(props: FormRowLayoutProps) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnFormRowLayout {...props} />;
  } else {
    return <LegacyFormRowLayout {...props} />;
  }
}

export function FormRowsGroupLayout(props: FormRowsGroupLayoutProps) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnFormRowsGroupLayout {...props} />;
  } else {
    return <LegacyFormRowsGroupLayout {...props} />;
  }
}

export default FormRowLayout;
